import React, { Fragment } from 'react';

import { isEmpty, isArray, map, noop, isString } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { GLOBAL_LABELS } from 'constants/common';
import { button as Button } from 'modules/button';
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { confirmationPromptWithIcon as ConfirmationPromptWithIcon } from 'ui/views/generic/confirmationPromptWithIcon';
 *
 * // render
 * <ConfirmationPromptWithIcon propName='propValue'/>
 */
export const confirmationPromptWithIcon = ( props ) => {
    return (
        <div className='ui-confirmation-prompt-with-icon'>
            <div className='ui-confirmation-prompt-with-icon__body'>

                {/* check if icon is not null, display icon in this case */}
                {
                    props.showIcon && (
                        <div className='ui-confirmation-prompt-with-icon__body__icon'>
                            <Icon name={ props.iconName } width='69' height='69' />
                        </div>
                    )
                }
                <h3 className='ui-confirmation-prompt-with-icon__body__title'>

                    {
                        ! isEmpty( props.message ) ? getLabel( props.message ): getLabel( GLOBAL_LABELS.DISPLAY_TEXT_ARE_YOU_SURE )
                    }
                </h3>
                
                {
                  !isEmpty( props.subMessage ) && isString( props.subMessage ) &&
                  <h4 className='ui-confirmation-prompt-with-icon__body__description' dangerouslySetInnerHTML={ { __html: props.subMessage } }></h4>
                }

            </div>
            <div className='ui-confirmation-prompt-with-icon__body__navigations'>

                {
                    isArray( props.actions ) && map( props.actions, ( action, index ) => {
                        return(
                            <Fragment key={`confirmation_Button_${ action.name }__${ index } `}>

                                <Button
                                    className='ui-confirmation-prompt-with-icon__body__navigations__button'
                                    label={ action.title }
                                    outline={ 'cancel' === action.name ? true : false }
                                    size='medium'
                                    onClick={ 'confirm' === action.name ? () => props.onConfirmClick( action ) : () =>  props.closeOverlay()  }
                                />

                            </Fragment>
                        );
                    } )
                }

            </div>
           
        </div>
    );
};

// set display name
confirmationPromptWithIcon.displayName = 'confirmationPromptWithIcon';

// set default props
confirmationPromptWithIcon.defaultProps = {
    showIcon: true,
    iconName: 'hollowExclaimaitionWarning',
    actions: [],
    onConfirmClick: noop,
    subMessage: null,
    message: null
};

// prop types
confirmationPromptWithIcon.propTypes = {};
